import React from "react";
export var usePlaylistBusinessTypesEdit = function (businessTypes) {
    var _a = React.useState(businessTypes.map(function (item) { return item.id; })), ids = _a[0], setIds = _a[1];
    var setFromBusinessTypes = function (businessTypes) {
        return setIds(businessTypes.map(function (item) { return item.id; }));
    };
    return { value: ids, set: setIds, setFromBusinessTypes: setFromBusinessTypes };
};
